import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { URLS } from 'config';

import './styles.scss';

const ProgressBar = ({ location }) => {
  const checkProgress = () => {
    switch (location.pathname) {
      case URLS.BUDGET:
        return 1;
      case URLS.NEEDCAR:
        return 2;
      case URLS.PHONE:
        return 3;
      case URLS.NAME:
        return 4;
      case URLS.BIRTHDAY:
        return 5;
      case URLS.GENDER:
        return 6;
      case URLS.WORKING:
        return 7;
      case URLS.EXPERIENCE:
        return 8;
      case URLS.MOUNTHLY:
        return 9;
      case URLS.DOWNPAYMENTS:
        return 9;
      case URLS.CONFIRMATION:
        return 10;
      case URLS.UPLOAD:
        return 11;
      default:
        return 0;
    }
  };

  return (
    <div className="progress-bar">
      {new Array(11).fill(0).map((el, index) => <span className={index < checkProgress() ? '-active' : ''} key={Math.random()} />)}
    </div>
  );
};

ProgressBar.propTypes = {
  // eslint-disable-next-line
  location: PropTypes.object.isRequired
};

export default withRouter(ProgressBar);



// WEBPACK FOOTER //
// ./src/components/ProgressBar/index.js